import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../../../utils/utils';
import { getOfferErrors } from '../../../../../../crud/offer.crud';

export type ImportError = {
  case: string;
  customStock: string;
  deliveryTime: string;
  error: string;
  partnumber: string;
  prices: { price: number; amount: number }[];
  storeStock: string;
};

export const useGetImportErrors = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingErrors, setLoading] = useState(false);
  const [errors, setErrors] = useState<ImportError[] | null>(null);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });

  const fetchImportErrors = useCallback(async (data: { id: number }) => {
    setLoading(true);
    getOfferErrors(data)
      .then((res: any) => {
        setErrors(res.data.data);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, per_page, total } = res.data;
        setPage({ page, perPage: per_page, total });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { fetchImportErrors, loadingErrors, errors, page };
};
